module.exports = __webpack_public_path__ + "static/c_sharp-ea2d453f7177fa2843268809f10f81db.png";